import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { FadeUp } from '../../../components/shared/Motion';
import { EditableText, HrefPill } from '../../components';
import { Icon as IconByName } from '../iconMap';

function BatchesTiming({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  return (
    <section className="relative py-24 lg:py-28 bg-olive-light overflow-hidden">
      <div className="absolute top-10 right-10 w-72 h-72 opacity-40 pointer-events-none" style={{ backgroundImage: 'radial-gradient(rgba(161,201,164,0.4) 1.5px, transparent 1.5px)', backgroundSize: '20px 20px' }} />
      <div className="container-page relative">
        <FadeUp className="text-center max-w-3xl mx-auto mb-14">
          <span className="eyebrow justify-center"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading_prefix} onChange={(t) => update({ heading_prefix: t })} as="span" />
            <span className="text-gradient"><EditableText value={data.heading_highlight} onChange={(t) => update({ heading_highlight: t })} as="span" /></span>
            <EditableText value={data.heading_suffix} onChange={(t) => update({ heading_suffix: t })} as="span" />
          </h2>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {items.map((b, i) => (
            <FadeUp key={i} delay={i * 0.1}>
              <div className="group relative h-full bg-white rounded-2xl shadow-md overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-25px_rgba(46,58,24,0.35)] transition-all duration-500 border border-olive/8">
                <div className="h-2 w-full" style={{ background: b.strip_color }} />
                <div className="p-7 flex flex-col h-full">
                  <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-olive-light text-olive shadow-[inset_0_0_0_1px_rgba(161,201,164,0.18)] mb-5">
                    <IconByName name={b.icon} size={26} />
                  </div>
                  <EditableText
                    value={b.title}
                    onChange={(t) => updateItem(i, { title: t })}
                    as="h3"
                    className="font-display text-xl font-bold text-olive-deep leading-tight"
                  />
                  <div className="mt-3 inline-flex w-fit items-center gap-1.5 bg-accent text-ink rounded-full px-4 py-1 text-xs font-bold tracking-wide">
                    <Clock size={13} />
                    <EditableText
                      value={b.timing}
                      onChange={(t) => updateItem(i, { timing: t })}
                      as="span"
                    />
                  </div>
                  <EditableText
                    value={b.desc}
                    onChange={(t) => updateItem(i, { desc: t })}
                    as="p"
                    multiline
                    className="mt-4 text-ink/70 leading-relaxed text-[15px] flex-1"
                  />
                  <Link to={b.cta?.href || '#'} className="mt-5 inline-flex items-center gap-2 text-olive font-semibold text-sm group/lnk">
                    <EditableText
                      value={b.cta?.label || 'Learn More'}
                      onChange={(t) => updateItem(i, { cta: { ...(b.cta || {}), label: t } })}
                      as="span"
                    />
                    <ArrowRight size={15} className="transition-transform group-hover/lnk:translate-x-1" />
                  </Link>
                  <HrefPill value={b.cta?.href} onChange={(h) => updateItem(i, { cta: { ...(b.cta || {}), href: h } })} />
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BatchesTiming;
